<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"consignee": "Consignee",
		"consignor": "Consignor",
		"deliveryParty": "Delivery Party",
		"despatchParty": "Despatch Party",
		"originalShipper": "Original Shipper",
		"originalDespatchParty": "Original Despatch Party",
		"finalDeliveryParty": "Final Delivery Party",
		"contactEmail": "Email",
		"contactName": "Contact Name",
		"contactPhone": "Phone Number",
		"country": "Country",
		"countryCode": "Country Code",
		"customerNumber": "Customer Number",
		"customsCreditNumber": "Customs Credit Number",
		"eori": "EORI",
		"exporterNumber": "Exporter Number",
		"gs1LocationNumber": "GS1 Locno.",
		"marks": "Marks",
		"name": "Name",
		"organizationNumber": "Organization Number",
		"postalCode": "Postal Code",
		"postalPlace": "Postal Place",
		"street": "Street",
		"vat": "MVA",
		"vendorNumber": "Vendor Number",
		"voec": "VOEC",
		"website": "Website"
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"consignee": "Mottaker",
		"consignor": "Avsender",
		"deliveryParty": "Leveringsaddresse",
		"despatchParty": "Henteaddresse",
		"originalShipper": "Original avsender",
		"originalDespatchParty": "Original henteaddresse",
		"finalDeliveryParty": "Endelig leveringsadresse",
		"contactEmail": "E-post",
		"contactName": "Contact navn",
		"contactPhone": "Telefon",
		"country": "Land",
		"countryCode": "Landkode",
		"customerNumber": "Kunde",
		"customsCreditNumber": "Tollkredittnummber",
		"eori": "EORI",
		"exporterNumber": "Eksportør nummer",
		"gs1LocationNumber": "GS1 Locno.",
		"marks": "Merknader",
		"name": "Navn",
		"organizationNumber": "Foretaksnummer",
		"postalCode": "Postnummer",
		"postalPlace": "Poststed",
		"street": "Gate",
		"vat": "MVA",
		"vendorNumber": "Leverandør",
		"voec": "VOEC",
		"website": "Internett"
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header icon="undefined" :text="$t(field)"/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-pane v-bind="paneOptions">
				<div class="address-pane">
					<TLabeledValue
						:label="$t('name')"
						:value="data.name"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('street')"
						:value="data.street"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('postalCode')"
						:value="data.postalCode"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('postalPlace')"
						:value="data.postalPlace"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('countryCode')"
						:value="data.countryCode"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('gs1LocationNumber')"
						:value="data.gs1LocationNumber"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>
			
			<t-pane v-bind="paneOptions" style="grid-area: 2 / 1">
				<div class="address-pane">
					<TLabeledValue
						:label="$t('customsCreditNumber')"
						:value="data.customsCreditNumber"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('vat')"
						:value="data.vat"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('voec')"
						:value="data.voec"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('organizationNumber')"
						:value="data.organizationNumber"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('exporterNumber')"
						:value="data.exporterNumber"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('eori')"
						:value="data.eori"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>

			<t-pane v-bind="paneOptions">
				<div class="address-pane">
					<TLabeledValue
						:label="$t('contactName')"
						:value="data.contactName"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('contactPhone')"
						:value="data.contactPhone"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('contactEmail')"
						:value="data.contactEmail"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('website')"
						:value="data.website"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>

			<t-pane v-bind="paneOptions">
				<div class="address-pane">
					<TLabeledValue
						:label="$t('customerNumber')"
						:value="data.customerNumber"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('vendorNumber')"
						:value="data.vendorNumber"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>
		</div>
	</t-vertical-panel>
</template>

<script>
export default {
	name: 'Address',
	props: {
		field: String,
		data: Object,
		op: String
	},
	data() {
		return {
			paneOptions: {
				border: 'default',
				background: 'tint1',
				borderRadius: '5px',
				style: { padding: '5px', }
			},
		};
	}
};
</script>
<style lang="scss" scoped>
.content {
	display: grid;
	grid-template-columns: repeat(2, minmax(300px, 1fr));
	column-gap: 15px;
	row-gap: 15px;
	margin: 10px;
}
.address-pane {
	display: grid;
	grid-template-columns: 1fr;
	grid-column-gap: 20px;
	grid-row-gap: 15px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>